// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"97":"455a8b75","260":"cd8f3171","405":"c0916bbc","986":"e6391d20"}[chunkId] + ".css";
};